
import { Component, Vue, Prop } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';
import { JobComplianceScheduledBoardData } from '@/models/JobComplianceTypes';

@Component({
  components: {
    Icon,
  },
})
export default class OpenSchedulerBoardFromJobLink extends Vue {
  @Prop({ type: Object, required: true }) public scheduleBoard: JobComplianceScheduledBoardData;
  @Prop({ type: String, required: true }) public date: string;
}
